import React, { useLayoutEffect } from "react";
import Header from "./Header";
import { clinicData } from "../mock";
import { useNavigate } from "react-router-dom";
const specialtyColors = {
  Orthopedics: "from-blue-500 to-blue-700",
  "Sports Therapy": "from-green-400 to-green-600",
  Neurology: "from-purple-500 to-purple-700",
  "General Therapy": "from-yellow-400 to-yellow-600",
  Default: "from-gray-400 to-gray-600",
};

const ChiefPhysiotherapistPage = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBookConsultation = () => {
    const contactSection = document.querySelector("#contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    } else {
      alert("Redirecting to consultation booking... (mock function)");
    }
  };

  // const qualifications = [
  //   { text: "Bachelor of Physiotherapy (B.P.T)", img: "https://images.unsplash.com/photo-1658235081483-8f06aa0882cf?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8R3JhZHVhdGlvbiUyMGNhcHxlbnwwfHwwfHx8MA%3D%3D" },
  //   { text: "Master of Physiotherapy (M.P.T) – Orthopedics specialization", img: "https://images.unsplash.com/photo-1627556704302-624286467c65?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
  //   { text: "Fellowship in Osteopathy", img: "https://images.unsplash.com/photo-1611784601600-ac6f688effdb?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjR8fEZlbGxvd3NoaXAlMjBpbiUyME9zdGVvcGF0aHl8ZW58MHx8MHx8fDA%3D" },
  //   { text: "Diploma in Chiropractic (International Institution)", img: "https://images.unsplash.com/photo-1659080907111-7c726e435a28?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8RGlwbG9tYSUyMGluJTIwQ2hpcm9wcmFjdGljJTIwKEludGVybmF0aW9uYWwlMjBJbnN0aXR1dGlvbil8ZW58MHx8MHx8fDA%3D" }
  // ];

  const certifications = [
    {
      text: "Trigger Point Dry Needling",
      img: "https://sa1s3optim.patientpop.com/assets/images/provider/photos/2202734.jpg",
    },
    {
      text: "Instrument-Assisted Soft Tissue Mobilization (IASTM)",
      img: "https://carolinapainandperformance.com/wp-content/uploads/2017/04/Instrument-Assisted-Soft-Tissue-Mobilization-1170x627.png",
    },
    {
      text: "Kinesio Taping",
      img: "https://media.istockphoto.com/id/1246919734/photo/kinesiology-taping-treatment-with-blue-and-pink-tape-on-athlete-patient-injured-arm.jpg?s=612x612&w=0&k=20&c=mARIShSLFhrYiOB8M_T_Fbw-iEnoMrLpgkQlzjESQWU=",
    },
    {
      text: "Manual Therapy",
      img: "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8TWFudWFsJTIwVGhlcmFweXxlbnwwfHwwfHx8MA%3D%3D",
    },
    {
      text: "Osteopathic Manipulative Techniques",
      img: "https://floydvalley.org/wp-content/uploads/2021/10/omt.jpg",
    },
    {
      text: "Chiropractic Adjustments",
      img: "https://images.unsplash.com/photo-1699523229921-ba6253ad0277?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fENoaXJvcHJhY3RpYyUyMEFkanVzdG1lbnRzfGVufDB8fDB8fHww",
    },
  ];

  // const achievements = [
  //   {
  //     text: "Trusted Physiotherapy Partner for Sports & Events",
  //     img: "https://plus.unsplash.com/premium_photo-1725576700671-28f9113cafa0?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8T2ZmaWNpYWwlMjBwaHlzaW90aGVyYXBpc3QlMjBmb3IlMjBwcmVtaWVyJTIwc3BvcnRzJTIwbGVhZ3VlcyUyMGFuZCUyMG5vdGFibGUlMjBldmVudHN8ZW58MHx8MHx8fDA%3D",
  //   },
  //   {
  //     text: "Trusted by Athletes, Celebrities & Leaders",
  //     img: "https://images.unsplash.com/photo-1659081451303-33bcb3c5e24d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fFBoeXNpY2lhbiUyMHRvJTIwbmF0aW9uYWwlMjBsZXZlbCUyMGF0aGxldGVzJTJDJTIwY2VsZWJyaXRpZXMlMkMlMjBhbmQlMjBWSVBzfGVufDB8fDB8fHww",
  //   },
  //   {
  //     text: "Expert in Advanced Rehabilitation Success",
  //     img: "https://plus.unsplash.com/premium_photo-1729286323649-e85fe188f3ce?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8aGVhdGhjYXJlJTIwdHJlYXRtZW50fGVufDB8fDB8fHww",
  //   },
  //   {
  //     text: "Leading Physiotherapist with Proven Expertise",
  //     img: "https://productimages.withfloats.com/serviceimages/actual/65bc7af23131ad92064b058bHow-physiotherapy-can-help-with-pain-relief-and-better-mobility-1",
  //   },
  //       {
  //     text: "Empowering Recovery Through Personalized Treatment",
  //     img: "https://twilightrecoverycenter.com/wp-content/uploads/2024/04/reevaluation-image.webp",
  //   },
  //     {
  //     text: "Dedicated to Excellence in Every Rehabilitation Journey",
  //     img: "https://t4.ftcdn.net/jpg/02/96/42/75/360_F_296427532_DTBcilpFpz4KyBg9rjScVrdWxPJlWFWZ.jpg",
  //   }
  // ];

  const expertiseAreas = [
    {
      text: "Paralysis & Neurological Rehabilitation",
      img: "https://media.istockphoto.com/id/2150666614/vector/facial-palsy-male-character-with-asymmetrical-face-nerve-damage-drooping-smile.jpg?s=612x612&w=0&k=20&c=bwcFeQSIQZmZroMzSmtg-Q1HmIq2EVky2jsKo5RvD0Y=",
    },
    {
      text: "Spine, Neck, and Back Pain Management",
      img: "https://img.freepik.com/premium-vector/woman-feeling-neck-back-pain-spine-disease-osteochondrosis-cervical-spine-treatment-neck-injury_538002-2639.jpg",
    },
    {
      text: "Frozen Shoulder & Joint Disorders",
      img: "https://www.wikihow.com/images/thumb/d/d1/Sleep-with-a-Frozen-Shoulder-Step-10.jpg/v4-460px-Sleep-with-a-Frozen-Shoulder-Step-10.jpg",
    },
    {
      text: "Sports Injuries & Muscle Strain",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqy9Maagn6NunIaz6uRn9wiThPa9BtAK5VQQ&s",
    },
    {
      text: "Arthritis & Chronic Pain",
      img: "https://thumbs.dreamstime.com/b/man-holding-hand-lumbar-spine-lower-back-pain-health-problem-muscle-osteoarthritis-rheumatoid-arthritis-spinal-hernia-kidney-397239897.jpg",
    },
    {
      text: "Pediatric & Geriatric Physiotherapy",
      img: "https://static.vecteezy.com/system/resources/thumbnails/068/439/890/small_2x/doctor-child-high-five-illustration-2023-free-vector.jpg",
    },
    {
      text: "Advanced Chiropractic & Osteopathic Adjustments",
      img: "https://www.shutterstock.com/image-vector/patient-rehabilitation-massage-chiropractors-masseur-600nw-2160670955.jpg",
    },
    {
      text: "Post-Surgical Recovery",
      img: "https://media.istockphoto.com/id/842883858/vector/surgery-and-hospitalization.jpg?s=612x612&w=0&k=20&c=-6x27gC5ZQlZ0ye_o7hurSNR43mfejoQ0FPdV8xmRlQ=",
    },
  ];
const otherDoctors = clinicData.teamMembers.filter(
    (member) => member.name !== "Dr. Harish Jasti"
  );
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      {/* Hero Section with Founder */}
     <section className="w-full min-h-[700px] bg-gradient-to-br from-white via-[#f9fbff] to-white flex flex-col md:flex-row items-center px-6 sm:px-12 md:px-20 py-16 md:py-20 gap-12 md:gap-16 select-none ">
  {/* Left: Image */}
  <div className="relative flex-1 max-w-md rounded-3xl overflow-hidden shadow-2xl w-full sm:w-[360px] md:w-full h-[360px] sm:h-[420px] md:h-auto">
    <img
      src="./Harish Jasti.webp"
      alt="Dr. Harish Jasti"
      className="w-full h-82 object-cover object-top rounded-3xl"
      loading="lazy"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent rounded-3xl pointer-events-none"></div>
    {/* Glow accent */}
    <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#204080]/20 rounded-full blur-3xl"></div>
  </div>

  {/* Right: Text */}
  <div className="flex-1 max-w-2xl px-2 sm:px-6">
    {/* Name */}
    <h1 className="text-4xl sm:text-5xl font-serif font-bold text-[#1a2d60] mb-3 leading-tight">
      Dr. Harish Jasti
    </h1>
    <div className="w-24 h-1 bg-[#204080] rounded-full mb-6"></div>

    {/* Credentials */}
    <p className="uppercase tracking-widest text-[#204080] font-medium mb-3 text-sm sm:text-base font-sans">
      B.P.T. PGDSP (Apollo), M.P.T (Ortho & Sports) · Fellowship in Osteopathy
    </p>
    <p className="text-sm sm:text-base text-gray-600 mb-8 font-bold font-sans">
      Diploma in Master of Chiropractor (Ackermann College, Sweden)
    </p>

    {/* Bio */}
    <p className="text-base sm:text-lg text-gray-800 max-w-xl leading-relaxed mb-8 font-sans">
      With more than 22 years of dedicated clinical expertise, Dr. Harish Jasti
      has guided thousands on their journey to recovery, combining advanced
      physiotherapy with compassionate care. Trusted by athletes and dignitaries
      alike, his approach is both world-class and deeply personal.
    </p>

    {/* Quote */}
    <blockquote className="text-lg sm:text-2xl italic text-gray-700 max-w-3xl mb-10 border-l-4 border-[#204080] pl-5 leading-relaxed font-serif">
      "Healing is a journey of strength, patience, and hope — Dr. Jasti guides
      you every step of the way."
    </blockquote>

  </div>
</section>

<section className="text-center mb-16 max-w-4xl mx-auto relative z-10">
          <h1 className="text-3xl md:text-4xl font-bold text-[#204080] font-serif mb-2">
           Our Expert Physiotherapy Team
          </h1>
          <p className="text-gray-700 text-lg">
            Our physiotherapists empower you to move better, recover faster, and live stronger.
          </p>
        </section>

        {/* Flip Card Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 max-w-6xl mx-auto z-10">
          {otherDoctors.map((doc) => {
            const gradientClass = specialtyColors[doc.specialty] || specialtyColors.Default;

            return (
              <div key={doc.id} className="group [perspective:1200px] w-full h-96">
                <div className="relative w-full h-full transition-transform duration-500 [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)] cursor-pointer">

                  {/* Front Side: Only Image + Name */}
                  <div
                    className={`absolute w-full h-full rounded-3xl shadow-xl hover:shadow-2xl bg-white flex flex-col items-center justify-center p-6 [backface-visibility:hidden] border-4 border-transparent`}
                    style={{
                      borderImageSlice: 1,
                      borderImageSource: `linear-gradient(45deg, var(--tw-gradient-stops))`,
                      "--tw-gradient-stops": `var(--tw-gradient-from, ${gradientClass.split(" ")[0]}), var(--tw-gradient-to, ${gradientClass.split(" ")[1]})`,
                    }}
                  >
                    <img
                      src={doc.image}
                      alt={doc.name}
                      className="w-56 h-56 object-cover object-top rounded-2xl shadow-md mb-4"
                    />
                    <h3 className="text-lg font-bold text-gray-900">{doc.name}</h3>
                    <p className="text-sm mb-2">{doc.credentials}</p>

                  </div>

                  {/* Back Side: Everything Else */}
                  <div
                    className={`absolute w-full h-full rounded-3xl shadow-xl bg-gradient-to-br ${gradientClass} text-white flex flex-col items-center justify-center p-6 [backface-visibility:hidden] [transform:rotateY(180deg)]`}
                  >
                    <h3 className="text-lg font-bold">{doc.name}</h3>
                    <h3 className="text-xl font-semibold mb-2">{doc.role || doc.credentials}</h3>
                    <p className="text-sm mb-2">{doc.specialty}</p>
                    <p className="text-sm mb-4 text-center">{doc.description}</p>
                    {doc.experience && (
                      <p className="text-sm font-light mb-4">{doc.experience} years experience</p>
                    )}
                    <button
                      onClick={() => navigate("/book-appointment")}
                      className="mt-2 px-6 py-2 bg-white text-blue-700 font-semibold rounded-xl shadow hover:scale-105 transition-transform duration-200"
                    >
                      Book Appointment
                    </button>
                  </div>

                </div>
              </div>
            );
          })}
        </div>
        {/* Achievements Section */}
<section className="py-20 bg-gradient-to-br from-slate-50 via-white to-slate-100">
  <div className="container mx-auto px-4 max-w-5xl">
    <div className="text-center mb-12">
      <h2 className="text-3xl md:text-4xl font-bold text-[#204080] font-serif mb-2">
        Achievements & Recognition
      </h2>
      <p className="text-gray-700 text-lg">
        Celebrating milestones of excellence, trust, and global recognition.
      </p>
    </div>

    <div className="space-y-10 relative">
      {/* Left Accent Line */}
      {[
        {
          text: "Trusted Physiotherapy Partner for Sports & Events",
          desc: "Trusted for sports injury care — from quick checkups to full recovery. Helping athletes heal faster, get back to the game, and stay confident.",
          img: "./events.jpeg",
        },
        {
          text: "Trusted by Athletes, Celebrities & Leaders",
          desc: "Trusted by sports professionals, celebrities, and leaders for safe and personalized recovery",
          img: "./cricketers.jpg",
        },
        {
          text: "Expert in Advanced Rehabilitation Success",
          desc: "Supporting patients every step of the way for successful rehabilitation and stronger health.",
          img: "/Awards.webp",
        },
        {
          text: "Dedicated to Excellence in Every Rehabilitation Journey",
          desc: "Committed to providing the best care in every patient’s rehabilitation journey",
          img: "./excellence.jpg",
        },
      ].map((achievement, index) => (
        <div
          key={index}
          className={`flex flex-col md:flex-row items-center gap-6 ${
            index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
          } relative`}
        >
          {/* Image */}
          <div className="flex-1 flex justify-center">
            <img
              src={achievement.img}
              alt={achievement.text}
              className="w-full max-w-sm rounded-2xl shadow-lg"
            />
          </div>

          {/* Text */}
          <div className="flex-1">
            <h3 className="text-xl md:text-2xl font-semibold text-[#204080] mb-3">
              {achievement.text}
            </h3>
            <p className="text-gray-700 leading-relaxed">
              {achievement.desc}
            </p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>


      {/* Section Template Function */}
      {[
        // { title: 'Educational Qualifications', data: qualifications },
        { title: "Certifications & Advanced Training", data: certifications },
        // { title: "Achievements & Recognition", data: achievements },
        { title: "Areas of Expertise", data: expertiseAreas },
      ].map((section, idx) => (
        <section
          key={idx}
          className={`py-20 ${
            idx % 2 === 0
              ? "bg-gradient-to-br from-white via-blue-50 to-slate-50"
              : "bg-white"
          }`}
        >
          <div className="container mx-auto px-4 max-w-6xl">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-[#204080] font-serif mb-2">
                {section.title}
              </h2>
              <p className="text-gray-700 text-lg">
                {section.title === "Areas of Expertise"
                  ? "Comprehensive care across all aspects of physiotherapy and rehabilitation"
                  : "Excellence and specialized training recognized worldwide"}
              </p>
            </div>

            <div
              className={`grid gap-6 ${
                section.data.length === 4
                  ? "grid-cols-1 md:grid-cols-2"
                  : section.data.length === 6
                  ? "grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
                  : "grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
              }`}
            >
              {section.data.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl hover:scale-[1.03] transition-all duration-300 text-center border border-gray-200"
                >
                  <div className="w-16 h-16 rounded-full overflow-hidden mx-auto mb-4 shadow-lg flex items-center justify-center">
                    {item.img ? (
                      <img
                        src={item.img}
                        alt={item.text}
                        className="w-full h-full object-cover"
                      />
                    ) : item.icon ? (
                      <item.icon className="text-white w-8 h-8 mx-auto" />
                    ) : null}
                  </div>
                  <h3 className="text-gray-800 font-semibold">{item.text}</h3>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default ChiefPhysiotherapistPage;
